module.exports = __webpack_public_path__ + "static/media/1.0e9b71cd.jpg";